import React from 'react';
import '../styles/Login.css';
import { urlApi } from '../helpers/functionHelpers';

const Login = () => {
  const handleLogin = () => {
    window.location.href = `${urlApi}/auth/azure`; // Redirige a la ruta del backend
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-title">Iniciar sesión</h1>
        <p>Por favor, inicia sesión con tu cuenta corporativa para continuar</p>
        <button className="login-button" onClick={handleLogin}>
          Iniciar sesión con Azure
        </button>
      </div>
    </div>
  );
};


export default Login;